import React, { useEffect, useState } from "react";
import BaseURL from "../../../assets/utils/baseUrl";
import MUIDataTable from "mui-datatables";
import { Button, Footer, HeaderAdmin } from "../../../components";
import { TextField, Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import { Loader } from "../../../assets";
import { Link } from "react-router-dom";

function KelolaBidang({ setToken }) {
  const [bidang, setBidang] = useState([]);
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [success, setSuccess] = useState(true);
  const [load, setLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [alertNamaBidang, setAlertNamaBidang] = useState(false);
  const [formData, setFormData] = useState({
    nama_bidang: "",
  });
  const [id, setId] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setLoading(true);
    const getDataBidang = async () => {
      await fetch(BaseURL + "index.php/api/Bidang")
        .then((res) => res.json())
        .then((data) => {
          setBidang(data.data);
          setLoading(false);
        });
    };
    getDataBidang();
  }, [load]);

  useEffect(() => {
    let tablesData = [];

    if (bidang.length > 0) {
      for (let i = 0; i < bidang.length; i++) {
        tablesData.push({
          nama_bidang: bidang[i].nama_bidang,
          tanggal_post: bidang[i].created_date,
          opsi: bidang[i].id_bidang,
        });
      }
    }
    setTableData(tablesData);
  }, [bidang]);

  const columns = [
    {
      name: "nama_bidang",
      label: "Nama Bidang",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div style={{ width: 200 }}>{value}</div>;
        },
      },
    },
    {
      name: "tanggal_post",
      label: "Tanggal Post",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return <div style={{ width: 100 }}>{value}</div>;
        },
      },
    },
    {
      name: "opsi",
      label: "Opsi",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="tooltip btn-hapus-row" onClick={() => hapus(value)}>
                <i className="fas fa-trash-alt"></i>
                <span className="tooltiptext">Hapus</span>
              </div>
              <div
                className="tooltip btn-edit-row"
                onClick={() => {
                  setUpdateModal(true);
                  openUpdateModal(value);
                }}
              >
                <i className="fas fa-edit"></i>
                <span className="tooltiptext">Update</span>
              </div>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: false,
  };

  const tambah = () => {
    if (formData.nama_bidang == "") {
      setAlertNamaBidang(true);
    } else {
      setAlertNamaBidang(false);
    }

    if (formData.nama_bidang !== "") {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "post");
      data.append("nama_bidang", formData.nama_bidang);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", date);

      try {
        fetch(BaseURL + "index.php/api/bidang", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              nama_bidang: "",
              id_bidang: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  const hapus = ($id) => {
    try {
      fetch(BaseURL + "index.php/api/bidang/" + $id, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then((data) => {
          setLoad(!load);
          if (data.status) {
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setPopUp(true);
        })
        .catch((error) => console.log("Gagal: ", error));
    } catch (error) {
      alert("Terjadi kesalahan pada sistem");
      console.log(error);
    }
  };

  const openUpdateModal = ($id) => {
    const getDataUpdate = async () => {
      await fetch(BaseURL + "index.php/api/bidang?id=" + $id)
        .then((res) => res.json())
        .then((data) => {
          setFormData({
            nama_bidang: data.data[0].nama_bidang,
          });
          setId($id);
          setModal(true);
        });
    };
    getDataUpdate();
  };

  const update = () => {
    if (formData.nama_bidang == "") {
      setAlertNamaBidang(true);
    } else {
      setAlertNamaBidang(false);
    }

    if (formData.nama_bidang !== "") {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "put");
      data.append("id_bidang", id);
      data.append("nama_bidang", formData.nama_bidang);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", date);
      data.append("updated_date", date);

      try {
        fetch(BaseURL + "index.php/api/bidang", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              nama_bidang: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  return (
    <div className="page">
      <HeaderAdmin title="Kelola Bidang" setToken={(e) => setToken(e)} />
      <div className="main-admin">
        <div className="container-admin">
          <div style={{ height: 50 }} />
          <div style={{ display: "flex" }}>
            <Link to="/admin/kelola-jabatan">
              <Button title={<i class="fas fa-arrow-left"></i>} type="danger" />
            </Link>
            <div style={{ width: 10 }}></div>
            <Button
              title="Tambah Bidang"
              type="primary"
              onClick={() => {
                setUpdateModal(false);
                setModal(true);
              }}
            />
          </div>
          <div style={{ height: 10 }}></div>
          {loading ? (
            <div className="loader">
              <img src={Loader}></img>
            </div>
          ) : (
            <MUIDataTable title={"Daftar Bidang"} data={tableData} columns={columns} options={options} download={false} className="table" />
          )}
        </div>
      </div>

      <Footer />

      {/* modal */}
      <div className={modal ? "darker-bg-admin" : "darker-bg-admin hide"}>
        {/* form */}
        <div className="modal-admin">
          <div className="form-admin">
            <TextField id="nama_bidang" label="Nama Bidang" variant="outlined" style={{ marginTop: 10, marginBottom: 10 }} onChange={(e) => setFormData({ ...formData, nama_bidang: e.target.value })} value={formData.nama_bidang} />
            {alertNamaBidang && <div className="danger-alert">Nama Bidang tidak boleh kosong</div>}
          </div>

          <div style={{ height: 30 }}></div>

          <div className="form-option">
            <Button
              title={updateModal ? "Update" : "Tambah"}
              type="primary"
              onClick={() => {
                if (updateModal) {
                  update();
                } else {
                  tambah();
                }
              }}
            />
            <div style={{ width: 10 }}></div>
            <Button
              title="Batal"
              type="danger"
              onClick={() => {
                setModal(false);
                setUpdateModal(false);
                setFormData({
                  nama_bidang: "",
                });
                setAlertNamaBidang(false);
              }}
            />
          </div>
        </div>
      </div>

      {/* message pop up */}
      <div className={popUp ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="pop-up-admin">
          <i className={success ? "fas fa-check-circle pop-up-logo" : "fas fa-times-circle pop-up-logo failed-pop-up"}></i>
          {success ? <p>Berhasil</p> : <p className={success ? "" : "failed-pop-up"}>Gagal</p>}
          <div style={{ height: 20 }}></div>
          <Button
            title="Tutup"
            type="primary"
            onClick={() => {
              setAlertNamaBidang(false);
              setPopUp(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KelolaBidang;
